<script>
import countries from "@/data/countries.json";
import usStates from "@/data/usStates.json";
import {addLocation} from "@/api/locations";
import {required, minLength, maxLength, numeric} from "vuelidate/lib/validators";
import swal from "sweetalert";

export default {
  name: "add-locations-modal",
  data() {
    return {
      show: true,
      form: {
        name: "",
        street: "",
        city: "",
        state: "Please select",
        zip: "",
        country: "United States"
      },
      countries: [],
      usStates: [],
      spinning: false,

    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1)
      },
      street: {
        required
      },
      city: {
        required
      },
      zip: {
        required,
        numeric,
        maxLength: maxLength(6),
      },
    },
  },
  mounted() {
    this.countries = countries;
  },
  computed: {
    countriesOptions() {
      return [
        {value: null, text: "Please select"},
        ...this.countries.map(list => {
          return {
            value: list.name,
            text: list.name
          };
        })
      ];
    },
    statesOptions() {
      return [
        {value: null, text: "Please select"},
        ...usStates.map(list => {
          return {
            value: list.name,
            text: list.name
          };
        })
      ];
    }
  },
  methods: {
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        swal("Invalid", "Please fill in the form correctly");
      } else {
        const payload = JSON.parse(
            JSON.stringify({
              location: {
                name: this.form.name,
                street: this.form.street,
                city: this.form.city,
                state: this.form.state,
                zip: this.form.zip,
                country: this.form.country
              }
            })
        );

        this.spinning = true;
        const response = await addLocation(payload);
        if (response.success) {
          this.$bvToast.toast(`Added`, {
            title: "Locations",
            autoHideDelay: 3000,
            appendToast: false,
            variant: "info"
          });
          setTimeout(() => {
            this.spinning = false;
            this.$refs["modal-add-location"].hide();
            this.$store.dispatch("getLocations");
          }, 2000);
        }


      }
    }
  }
};
</script>

<template>
  <b-modal
      id="modal-add-location"
      ref="modal-add-location"
      title="Create Locations"
      no-close-on-esc
      no-close-on-backdrop
      centered
      hide-footer
  >
    <b-form
        v-on:submit.prevent="onSubmit"
        method="POST"
        accept-charset="UTF-8"
        enctype="multipart/form-data"
        id="mainForm"
    >
      <b-form-group id="input-group-name" label="Name:" label-for="input-name"
                    :class="{ 'form-group--error': $v.form.name.$error }">
        <b-form-input
            id="input-name"
            v-model.trim="$v.form.name.$model"
            type="text"
            required
            placeholder="Enter name"
        ></b-form-input>
        <p style="color:#F64E60; margin-top: 5px" class="error">
          <span class="d-block p-1" v-if="!$v.form.name.required">Field is required</span>
          <span class="d-block p-1" v-if="!$v.form.name.minLength">Field must have at least
            {{ $v.form.name.$params.minLength.min }} letters</span>

        </p>
      </b-form-group>
      <b-form-group
          id="input-group-street"
          label="Street:"
          label-for="input-street"
          :class="{ 'form-group--error': $v.form.street.$error }"
      >
        <b-form-input
            id="input-street"
            v-model="$v.form.street.$model"
            required
            placeholder="Enter street"
        ></b-form-input>
        <p style="color:#F64E60; margin-top: 5px" class="error">
          <span class="d-block p-1" v-if="!$v.form.street.required">Field is required</span>
        </p>
      </b-form-group>
      <b-row>
        <b-col>
          <b-form-group
              id="input-group-city"
              label="City:"
              label-for="input-city"
              :class="{ 'form-group--error': $v.form.city.$error }"
          >
            <b-form-input
                id="input-city"
                v-model="$v.form.city.$model"
                type="text"
                required
            ></b-form-input>
            <p style="color:#F64E60; margin-top: 5px" class="error">
              <span class="d-block p-1" v-if="!$v.form.street.required">Field is required</span>
            </p>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              id="input-group-state"
              label="State:"
              label-for="input-state"
          >
            <b-form-select
                id="input-state"
                v-model="form.state"
                :options="statesOptions"
                required
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="input-group-zip" label="Zip:" label-for="input-zip"
                        :class="{ 'form-group--error': $v.form.zip.$error }">
            <b-form-input
                id="input-zip"
                v-model="$v.form.zip.$model"
                type="text"
                required
            ></b-form-input>
            <p style="color:#F64E60; margin-top: 5px" class="error">
              <span class="d-block p-1" v-if="!$v.form.zip.required">Field is required</span>
              <span class="d-block p-1" v-if="!$v.form.zip.numeric || !$v.form.zip.maxLength">Invalid ZIP Code</span>
            </p>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              id="input-group-country"
              label="Country:"
              label-for="select-template"
          >
            <b-form-select
                id="select-country"
                v-model="form.country"
                :options="countriesOptions"
                required
                disabled
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-button
          type="submit"
          class="float-right"
          variant="primary"
          v-if="!spinning"
      >
        Add Location
      </b-button>
      <b-spinner
          v-show="spinning"
          label="Spinning"
          class="float-right"
      ></b-spinner>
    </b-form>
  </b-modal>
</template>
